import { render } from "./StudentLifeModal.vue?vue&type=template&id=28f59ce6"
import script from "./StudentLifeModal.vue?vue&type=script&lang=js"
export * from "./StudentLifeModal.vue?vue&type=script&lang=js"
script.render = render

export default script